import { classNames } from '@/utils'
import { ReactNode } from 'react'

type FormControlProps = {
  children: ReactNode
  messageError?: string
  label?: string
  isRequired?: boolean
  className?: string
  customElement?: JSX.Element
}
export const FormControl = ({
  children,
  label,
  messageError,
  isRequired,
  className,
  customElement,
}: FormControlProps) => {
  return (
    <div className={classNames('flex flex-col w-full gap-2', className)}>
      <div className="flex justify-between items-end">
        {label && (
          <span className="text-gray-400 text-xs uppercase">
            {label} {isRequired && <span className="text-red">*</span>}
          </span>
        )}
        {customElement}
      </div>
      <div className="flex flex-col gap-[5px]">
        {children}
        {messageError && <p className="text-red text-xs">{messageError}</p>}
      </div>
    </div>
  )
}
